import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    form: {
      name: null,
      phone: null,
      procedures: null,
      email: null,
      location: null,
      website: null,
      about: null,
      type: null,
      lat: null,
      lng: null,
      logo: null,
      cover: null,
    },
    types: [
      { value: 0, text: "أسلامي" },
      { value: 1, text: "تجاري" },
    ],
  },
  mutations: {
    SET_BANK_INFO: (state, data) => Object.assign(state.form, data),
  },
  getters: {
    bank: (state) => {
      let bank = new FormData();
      bank.append("cover", state.form.cover);
      bank.append("logo", state.form.logo);
      bank.append("name", state.form.name);
      bank.append("email", state.form.email);
      bank.append("location", state.form.location);
      bank.append("website", state.form.website);
      bank.append("about", state.form.about);
      bank.append("type", state.form.type);
      bank.append("phone", state.form.phone);
      bank.append("lat", state.form.lat);
      bank.append("lng", state.form.lng);
      return bank;
    },
  },
  actions: {
    async get({ commit }, id) {
      const { payload } = await $http.get(`bank-admin/bank-info`);
      commit("SET_BANK_INFO", payload);
    },
    async show({ commit }, item) {
      commit("SET_BANK_INFO", item);
    },
    async update({ getters }) {
      return await $http.post(`bank-admin/bank-info`, getters.bank);
    },
  },
};
